'use strict';

(function () {
    'use strict';

    authService.$inject = ['$http', '$q', 'appConfig', 'localStorageService'];
    angular.module('app.services').factory('authService', authService);

    function authService($http, $q, appConfig, localStorageService) {
        'ngInject';

        var service = {
            login: login,
            logout: logout,
            getRoles: getRoles,
            hasValidToken: hasValidToken,
            isTokenExpired: isTokenExpired
        };

        return service;

        ////////////////

        /**
         * 
         * @param {*} email 
         * @param {*} password 
         */
        function login(email, password) {

            var data = {
                email: email,
                password: password
            };

            return $http.post(appConfig.apiUrl + '/rpc/login', JSON.stringify(data)).then(function (r) {
                var token = _.get(r.data, '0.token', undefined);

                var user = {
                    email: email,
                    token: token,
                    timestamp: moment()
                };

                localStorageService.set('authUser', user);
                return user;
            });
        }

        /**
         * 
         */
        function logout() {
            localStorageService.remove('authUser');
            return $q.when(true);
        }

        function getRoles() {

            return $http.get(appConfig.apiUrl + '/get_roles').then(function (r) {
                return _.map(r.data, 'rolname');
            });
        }

        /**
         * 
         */
        function hasValidToken() {
            var defer = $q.defer();

            if (isTokenExpired()) {
                defer.reject(false);
            } else {
                defer.resolve(true);
            }

            return defer.promise;
        }

        function isTokenExpired() {
            var user = localStorageService.get('authUser');
            if (user && user.timestamp) {
                return moment().diff(user.timestamp, 'seconds') > 86400;
            }

            return true;
        }
    }
})();